import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Stack } from '@mui/material';

import { AppDispatch, RootState } from 'redux/store';
import { setMyPicture, removeMyPicture } from 'redux/slices/user/userSlice';
import ChangePhoto from 'pages/Account/ChangePhoto';
import CustomButton from 'components/Common/Button';
import CardWrapper from 'components/Common/CardWrapper';

function AccountChangePhoto() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const userImg = useSelector((state: RootState) => state.user.userInfo?.imgUrl);
    const [imgValue, setImgValue] = useState<string | Blob>('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userImg) {
            setImgValue(userImg);
        } else {
            setImgValue('');
        }
    }, [userImg, dispatch]);

    const onSaveClick = async () => {
        if (!(imgValue instanceof Blob)) return;
        try {
            setLoading(true);
            const res: any = await dispatch(setMyPicture({ file: imgValue }));
            if (!res?.error) {
                navigate(-1);
            }
        } catch (error) {
            console.log('upload img error');
        } finally {
            setLoading(false);
        }
    };

    const onRemoveClick = async () => {
        // Local selection only — clear without hitting the API.
        if (!userImg) {
            return setImgValue('');
        }
        try {
            setLoading(true);
            const res: any = await dispatch(removeMyPicture());
            if (!res?.error) {
                setImgValue('');
            }
        } catch (error) {
            console.log('remove img error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <CardWrapper>
            <Stack justifyContent="center">
                <ChangePhoto isLoading={loading} onRemoveClick={onRemoveClick} imgValue={imgValue as string} setImgValue={setImgValue} />
                {imgValue && (
                    <Stack width="100%" alignItems="center" mt={4}>
                        <CustomButton
                            disabled={typeof imgValue === 'string'}
                            width="30%"
                            title="Save"
                            loading={loading}
                            onClick={onSaveClick}
                        />
                    </Stack>
                )}
            </Stack>
        </CardWrapper>
    );
}

export default AccountChangePhoto;
